module.exports = __webpack_public_path__ + "static/media/3d-controls-selected-icon.239a4bc9.svg";